import { useRef } from "react";
import constate from "constate";
import { useDtfConfig, useDtfChannel } from "@design-lab/shared/hooks/useDtfChannel";

function useDtfInitCreator() {
  const activeSides = useRef<Record<string, string>>({});
  const initConfig = useDtfConfig();
  const channel = useDtfChannel();

  const markSideAsActive = (side: string, processTimeStamp: string) => {
    activeSides.current[side] = processTimeStamp;
  };

  const markSideAsDeleted = (side: string) => {
    delete activeSides.current[side];
  };

  const isSideActive = (side: string, processTimeStamp: string) =>
    activeSides.current[side] === processTimeStamp;

  return {
    initConfig,
    channel,
    markSideAsActive,
    markSideAsDeleted,
    isSideActive
  };
}

// Re-export the hooks for backward compatibility
export { useDtfConfig, useDtfChannel };

export const [DtfInitProvider, , , useDtfSideTracking] = constate(
  useDtfInitCreator,
  value => value.initConfig,
  value => value.channel,
  value => ({
    markSideAsActive: value.markSideAsActive,
    markSideAsDeleted: value.markSideAsDeleted,
    isSideActive: value.isSideActive
  })
);
